import { AssineButton } from "components/elements/AssineButton";
import React from "react";
import { NavLink } from "react-router-dom";

export const PisDialog = () => {
  return (
    <div className={"level-2 gp_alert_advice"}>
      <div className={"icon"}>
        <svg width="36" height="36" viewBox="0 0 36 36">
          <path d="M6.4,36V32.836a3.17,3.17,0,0,1,2.11-2.983V18a9.492,9.492,0,0,1,18.985,0V29.853a3.17,3.17,0,0,1,2.11,2.983V36Zm2.11-3.164V33.89H27.492V32.836a1.056,1.056,0,0,0-1.055-1.055H9.563A1.056,1.056,0,0,0,8.508,32.836ZM10.617,18V29.672H25.383V18a7.383,7.383,0,0,0-14.765,0Zm6.328,7.383v-2.11h2.11v2.11Zm0-4.218V14.836h2.11v6.329Zm14.765-2.11v-2.11H36v2.11ZM0,19.055v-2.11H4.289v2.11ZM4.576,6.068,6.068,4.576,9.05,7.559,7.559,9.051ZM26.95,7.559l2.983-2.984,1.491,1.492L28.441,9.05Zm-10-3.27V0h2.11V4.289Z" fill="#933ec5" />
        </svg>
      </div>
      <h3>Informe seu PIS</h3>
      <p>Para que possamos efetuar o pagamento pelas suas comissões precisamos que você preencha o PIS <NavLink to={"/glampartner/dados-financeiros"} className={"linkAdvice"}>AQUI</NavLink></p>
    </div>
  )
}

export const ActivateDialog = ({ onClick }) => {
  return (
    <div className={"level-2 gp_alert_ativar"}>
      <div className={"icon"}>
        <svg width="36" height="36" viewBox="0 0 36 36">
          <path d="M6.4,36V32.836a3.17,3.17,0,0,1,2.11-2.983V18a9.492,9.492,0,0,1,18.985,0V29.853a3.17,3.17,0,0,1,2.11,2.983V36Zm2.11-3.164V33.89H27.492V32.836a1.056,1.056,0,0,0-1.055-1.055H9.563A1.056,1.056,0,0,0,8.508,32.836ZM10.617,18V29.672H25.383V18a7.383,7.383,0,0,0-14.765,0Zm6.328,7.383v-2.11h2.11v2.11Zm0-4.218V14.836h2.11v6.329Zm14.765-2.11v-2.11H36v2.11ZM0,19.055v-2.11H4.289v2.11ZM4.576,6.068,6.068,4.576,9.05,7.559,7.559,9.051ZM26.95,7.559l2.983-2.984,1.491,1.492L28.441,9.05Zm-10-3.27V0h2.11V4.289Z" fill="#F9EBFF" />
        </svg>
      </div>
      <div className={"alert-content"}>
        <div className={"alert-description"}>
          <h3 className={"titulo-alerta"}>Atenção!</h3>
          <p>Você ainda não se ativou no programa! Ao se ativar você concorda com os <a href="/glampartner/termos" className={"linkWarning"}>termos e condições de uso</a>
          </p>
        </div>

        <div>
          <button id="ativarGlampartner"
            className="btn btn-violet-alert gbBt small"
            onClick={onClick}>Ativar</button>
        </div>
      </div>


    </div>
  )
}

export const UseVoucherDialog = ({ onClick }) => {
  return (
    <div className={"level-2 gp_alert_ativar"}>
      <div className={"icon"}>
        <svg width="36" height="36" viewBox="0 0 36 36">
          <path d="M6.4,36V32.836a3.17,3.17,0,0,1,2.11-2.983V18a9.492,9.492,0,0,1,18.985,0V29.853a3.17,3.17,0,0,1,2.11,2.983V36Zm2.11-3.164V33.89H27.492V32.836a1.056,1.056,0,0,0-1.055-1.055H9.563A1.056,1.056,0,0,0,8.508,32.836ZM10.617,18V29.672H25.383V18a7.383,7.383,0,0,0-14.765,0Zm6.328,7.383v-2.11h2.11v2.11Zm0-4.218V14.836h2.11v6.329Zm14.765-2.11v-2.11H36v2.11ZM0,19.055v-2.11H4.289v2.11ZM4.576,6.068,6.068,4.576,9.05,7.559,7.559,9.051ZM26.95,7.559l2.983-2.984,1.491,1.492L28.441,9.05Zm-10-3.27V0h2.11V4.289Z" fill="#933ec5" />
        </svg>
      </div>
      <h3> Queremos enviar sua primeira caixa pelo programa!</h3>
      <p>
        Clique <a onClick={onClick} className={"linkWarning"}>AQUI</a> para preencher seus dados de envio.
          </p>
      <p>
        <small>
          <strong>Importante:</strong> atualize a página aberta após o carregamento inicial para que seus dados sejam devidamente carregados.
      </small>
      </p>
    </div>
  )
}

export const SubscribeDialog = ({ personalUseCoupon, Authorization, personId, subscriberId, subscriptionTypeId}) => {
  return (
    <div className={"level-2 gp_alert_advice"}>
      <div className={"icon"}>
        <svg width="36" height="36" viewBox="0 0 36 36">
          <path d="M6.4,36V32.836a3.17,3.17,0,0,1,2.11-2.983V18a9.492,9.492,0,0,1,18.985,0V29.853a3.17,3.17,0,0,1,2.11,2.983V36Zm2.11-3.164V33.89H27.492V32.836a1.056,1.056,0,0,0-1.055-1.055H9.563A1.056,1.056,0,0,0,8.508,32.836ZM10.617,18V29.672H25.383V18a7.383,7.383,0,0,0-14.765,0Zm6.328,7.383v-2.11h2.11v2.11Zm0-4.218V14.836h2.11v6.329Zm14.765-2.11v-2.11H36v2.11ZM0,19.055v-2.11H4.289v2.11ZM4.576,6.068,6.068,4.576,9.05,7.559,7.559,9.051ZM26.95,7.559l2.983-2.984,1.491,1.492L28.441,9.05Zm-10-3.27V0h2.11V4.289Z" fill="#933ec5" />
        </svg>
      </div>
      <div className={"alert-content"}>
        <div className={"alert-description"}>
          <h3 className={"titulo-alerta"}>Receba a sua Glambox com 50% de desconto</h3>
          <p>Ao ativar a sua Glambox, você terá 50% de desconto no plano mensal</p>
        </div>
        <AssineButton personalUseCoupon={personalUseCoupon}
          Authorization={Authorization}
          personId={personId}
          subscriberId={subscriberId}
          subscriptionTypeId={subscriptionTypeId}
          >
          Assine
        </AssineButton>
      </div>
    </div>
  );

}
